module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1dc60808!./packages/dof-searchbar/colmo.css
// module id = 441
// module chunks = 0 1